import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Heading, Panel, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function GeneratePasswordError() {
  return (
    <Panel>
      <div className="flex flex-col items-center">
        <Heading font="ttfirs" tone="neutral" variant="h3" weight="bold">
          {generalErrorMessage}
        </Heading>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="lock-alt-incircle-fail"
        />
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          Nie mogliśmy wygenerować nowego hasła do konfiguracji modemu.
        </Text>
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          Spróbuj jeszcze raz.
        </Text>
      </div>
      <Separator size="xs" tone="invisible" />
      <div className="flex flex-col justify-center from-tablet:flex-row">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "ftth" })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="primary"
          >
            zamknij
          </A>
        </Link>
      </div>
    </Panel>
  );
}
